import { serviceMaker, methods } from '../service';

export const LOGIN = (payload) =>
  serviceMaker(`/authentication`, methods.POST, null, payload);
